<script setup lang="ts">
import { TriangleAlert } from 'lucide-vue-next'
const { t } = useI18n()

defineProps<{
  isOpen: boolean
  handleClose: (isOpen: boolean) => void
}>()

const emit = defineEmits<{ (e: 'onConfirm'): void; (e: 'onCancel'): void }>()
</script>

<template>
  <BaseModal :is-open="isOpen" size="lg" :show-footer="false" @close="handleClose(false)">
    <div class="flex w-full flex-row justify-center">
      <div class="flex h-10 w-10 items-center justify-center rounded-full bg-red-100">
        <TriangleAlert class="h-6 w-6 text-red-500" />
      </div>
    </div>

    <p class="mt-5 text-center font-semibold">
      {{ t('pages.marketingFlow.marketingFlowEditPage.replaceLegacyConfirmation') }}
    </p>

    <p class="mb-5 mt-2 text-sm text-foreground-secondary text-center">
      {{ t('pages.marketingFlow.marketingFlowEditPage.replaceLegacyDisclaimer') }}
    </p>

    <div class="flex w-full flex-row justify-center">
      <Button variant="outline" class="mr-3 flex-1" @click="emit('onCancel')">
        <span class="text-foreground">{{
          t('pages.marketingFlow.marketingFlowEditPage.replaceLegacyButtonCancel')
        }}</span>
      </Button>

      <Button variant="default-primary" class="flex-1" @click="emit('onConfirm')">
        {{ t('pages.marketingFlow.marketingFlowEditPage.replaceLegacyButton') }}
      </Button>
    </div>
  </BaseModal>
</template>
